module.exports = __webpack_public_path__ + "static/media/emperorPenguins.0ba31bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/emperorPenguins.jpg
// module id = 109
// module chunks = 0